import { faqs } from '@/mocks/gossip';

const principles = [
  { icon: 'ri-eye-2-line', t: '先看事实，再开麦', d: '点评基于画面与可见细节，不脑补不臆断，把判断依据摆在明面。' },
  { icon: 'ri-chat-1-line', t: '毒舌但不刻薄', d: '敢说真话，也尊重每一个大胆尝试。翻车要聊，亮点也别放过。' },
  { icon: 'ri-quill-pen-line', t: '审美无唯一标准', d: '你的观点跟小编不同很正常，评论区才是这场吃瓜的最终舞台。' },
];

export default function Talk() {
  return (
    <section id="talk" className="relative w-full bg-background-100/70 py-16 md:py-20">
      <div className="mx-auto grid max-w-[1240px] grid-cols-1 gap-10 px-4 md:px-6 lg:grid-cols-2">
        {/* 左：小编开麦 */}
        <div>
          <p className="mb-3 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.24em] text-secondary-700">
            <i className="ri-chat-smile-3-line text-base"></i>
            EDITOR'S VOICE
          </p>
          <h2 className="rule-line font-display text-3xl font-black text-foreground-950 md:text-4xl">
            小编开麦：开一份吃瓜心得
          </h2>
          <p className="mt-6 text-sm leading-relaxed text-foreground-700">
            红毯是少数让「好看」和「有戏」同时发生的地方。我们不做高高在上的审判官，
            而是站到离现场最近的位置，把每一次出场的门道讲给你听。以下是我们写瓜时最看重的三条底线。
          </p>

          <div className="mt-8 space-y-4">
            {principles.map((p) => (
              <div
                key={p.t}
                className="flex gap-4 rounded-xl border border-background-200/80 bg-background-50 p-5"
              >
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-xl text-primary-600">
                  <i className={p.icon}></i>
                </span>
                <div>
                  <h3 className="font-display text-lg font-bold text-foreground-950">{p.t}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{p.d}</p>
                </div>
              </div>
            ))}
          </div>

          {/* 引用块 */}
          <blockquote className="mt-8 rounded-r-xl border-l-[4px] border-primary-500 bg-foreground-50 p-6">
            <p className="font-display text-xl font-bold leading-relaxed text-foreground-900">
              「穿得对的人各有各的道理，翻车的现场总是相似——
              <span className="text-primary-600">要么抢了衣服的戏，要么输了衣服的仗。</span>」
            </p>
            <footer className="mt-4 flex items-center gap-2 text-xs text-foreground-500">
              <span className="inline-block h-px w-8 bg-foreground-400"></span>
              八卦吃瓜 · 本期卷首语
            </footer>
          </blockquote>
        </div>

        {/* 右：吃瓜 FAQ */}
        <div>
          <p className="mb-3 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.24em] text-primary-500">
            <i className="ri-question-line text-base"></i>
            FAQ
          </p>
          <h2 className="rule-line font-display text-3xl font-black text-foreground-950 md:text-4xl">
            吃瓜前的常见疑问
          </h2>
          <p className="mt-6 text-sm leading-relaxed text-foreground-700">
            第一次来的朋友可以先看这里。关于栏目口径、更新节奏和我们的点评立场，答案都在下面，点开即可。
          </p>

          <div className="mt-8 space-y-3">
            {faqs.map((f, i) => (
              <details
                key={f.q}
                className="group rounded-xl border border-background-200/80 bg-background-50"
                open={i === 0}
              >
                <summary className="flex cursor-pointer list-none items-center justify-between gap-3 px-5 py-4 font-medium text-foreground-900 [&::-webkit-details-marker]:hidden">
                  <span className="flex items-center gap-3">
                    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-secondary-100 font-display text-sm font-bold text-secondary-900">
                      {i + 1}
                    </span>
                    {f.q}
                  </span>
                  <i className="ri-add-line text-lg text-foreground-400 transition-transform duration-300 group-open:rotate-45"></i>
                </summary>
                <p className="border-t border-background-200/70 px-5 py-4 pl-[4.75rem] text-sm leading-relaxed text-foreground-600">
                  {f.a}
                </p>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}